module.exports = __webpack_public_path__ + "static/media/horizontal-preto.b069bc1b.svg";